module.exports = __webpack_public_path__ + "static/media/splootsvid_final.4ce2b132.mp4";